import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import IngredientCard from '../components/IngredientCard';

import { getIngredients } from '../services/fetchIngredient';

function ExploreDrinksIngredients() {
  const [ingredients, setIngredients] = useState([]);

  useEffect(() => {
    async function fetchIngredients() {
      try {
        const ingredientsList = await getIngredients('drinks');
        setIngredients(ingredientsList);
      } catch (error) {
        global.alert('Não foram encontrados ingredientes');
      }
    }
    fetchIngredients();
  }, []);

  return (
    <div className="ingredients-page">
      <Header Title="Ingredients" />
      <div className="ingredients-section">
        {ingredients.map((ingredient, index) => (
          <IngredientCard
            key={ index }
            index={ index }
            ingredient={ ingredient }
            type="drinks"
          />
        ))}
      </div>
      <Footer />
    </div>
  );
}

export default ExploreDrinksIngredients;
